import { Type, type Static } from "@fastify/type-provider-typebox";

export const PalletBody = Type.Object({
  height: Type.String(),
  dimensionUnit: Type.Optional(Type.String()),
  weight: Type.String(),
  weightUnit: Type.Optional(Type.String()),
  isStacked: Type.Optional(Type.Boolean()),
});

export const PalletResponse = Type.Object({
  id: Type.Integer(),
  height: Type.String(),
  dimensionUnit: Type.String(),
  weight: Type.String(),
  weightUnit: Type.String(),
  isStacked: Type.Boolean(),
  shipmentId: Type.Integer(),
});

export type PalletBody = Static<typeof PalletBody>;
export type PalletResponse = Static<typeof PalletResponse>;

export const CreatePalletsBody = Type.Array(PalletBody);
export type CreatePalletsBody = Static<typeof CreatePalletsBody>;

export const CreatePalletsResponse = Type.Array(PalletResponse);
export type CreatePalletsResponse = Static<typeof CreatePalletsResponse>;
